import React, { useEffect, useState } from "react";
import { I18nextProvider } from "react-i18next";
import axios from "axios";
import { createUnsubI18n } from "./i18nUnsub";
import { getMessageType } from "./utils/helpers";

const UnsubI18nProvider = ({ children }) => {
  const [i18nInstance, setI18nInstance] = useState(null);

  useEffect(() => {
    let mounted = true;
    (async () => {
      try {
        const lang = getMessageType(window.location.search);
        const res = await axios.get(`/iterableUnsub_translations/${lang}.json`);
        const data = res.data || {};

        const resources = {
          [lang]: {
            translation: data,
          },
        };

        const inst = await createUnsubI18n({ lng: lang, resources });
        if (mounted) setI18nInstance(inst);
      } catch (e) {
        console.error("Failed to init unsub i18n:", e);
      }
    })();

    return () => {
      mounted = false;
    };
  }, []);

  if (!i18nInstance) return null;

  return <I18nextProvider i18n={i18nInstance}>{children}</I18nextProvider>;
};

export default UnsubI18nProvider;